const WalletButton = ({ onClick, label = '$', color = '#fff' }) => (
  <button 
    onClick={onClick} 
    style={{
      position: 'static', // убираем фиксированную позицию для использования в группе
      fontSize: '1.2em',
      border: 'none',
      background: color,
      borderRadius: '50%',
      width: 48,
      height: 48,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      cursor: 'pointer'
    }}
    aria-label={`Wallet ${label}`}
  >
    {label}
  </button>
);

export default WalletButton;